import { render } from "./UserPresence.vue?vue&type=template&id=0908ebdc&scoped=true"
import script from "./UserPresence.vue?vue&type=script&lang=js"
export * from "./UserPresence.vue?vue&type=script&lang=js"

import "./UserPresence.vue?vue&type=style&index=0&id=0908ebdc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0908ebdc"]])

export default __exports__